// l10n status: partially
import { CreateComponent } from "components/utils/CreateComponent.js"
import { useState } from "react"
import rec from "img/recording_indicators/rec.svg"
import rec_successful from "img/recording_indicators/rec_successful.svg"
import rec_failed from "img/recording_indicators/rec_failed.svg"
import rec_series from "img/recording_indicators/rec_series.svg"
import rec_series_episode_successful from "img/recording_indicators/rec_series_episode_successful.svg"
import recording_archived from "img/recording_indicators/recording_archived.svg"
import recording_status from "img/recording_indicators/recording_status.svg"
import recording_status_series from "img/recording_indicators/recording_status_series.svg"
import recording_failed from "img/recording_indicators/recording_failed.svg"
import recording_visibility from "img/recording_indicators/recording_visibility.svg"
import { rootStore } from "store/RootStore"
import { computed } from "mobx"
import { moment } from "store/util/moment"
import { eventId, seriesId, title } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"

import "./recordingIndicators.css"

// cache to reduce Recordings requests
const availabilityEndCache = new Map()

export const RecordingIndicators = CreateComponent(null, false, true, ({ event, showText }) => {
	const _eventId = eventId(event)
	const _seriesId = seriesId(event)
	const [AvailabilityEnd, setAvailabilityEnd] = useState(null)
	if (!_eventId || !title(event)) return (<></>)
	// Potential alternative to retrieve AvailabilityEnd from RecordingsList if StartTime and EndTime criteria
	// would be used in GetRecordingsMarkers, but GetRecordingsMarkers would have a huge time impact
	/*
	console.debug("RecordingIndicators", event, rootStore.page.Recordings.ListPage)
	rootStore.page.Recordings.ListPage.recList.DataArr?.map(i => {
		if (_eventId === i.EventId) console.debug("i", i.EventId, i.AvailabilityEnd)
	})
	*/

	// computed sometimes would not return the current marker
	//const marker = computed(() => rootStore.page.Recordings.Manager.getMarker(_eventId, null)).get()
	const marker = rootStore.page.Recordings.Manager.getMarker(_eventId, null)
	// MTVW-820: removed AvailabilityStart and AvailabilityEnd from marker because it had a huge time impact on getting markers,
	// fetch recording instead
	if (marker) {
		//console.debug("recType", marker.recType, marker, event?.Title)
		if (!availabilityEndCache.get(_eventId)) {
			const recs = rootStore.api.GetRecordings({ ...{ isRecorded: true, isPlanned: true, iLimit: 1, isChildRecordings: true, isSortDesc: false }, ...{ Ids: marker.id } })
			const fetchRecording = async () => {
				const result = await recs.fetchDataAsync()
				//console.debug("RecordingIndicators marker %o, recs %o, res %o", marker, recs, recs.DataMain.AvailabilityEnd)
				marker.AvailabilityEnd = recs.DataMain?.AvailabilityEnd
				availabilityEndCache.set(_eventId, recs.DataMain?.AvailabilityEnd)
				// MTVW-972: reduce display lag
				setAvailabilityEnd(marker.AvailabilityEnd)
			}
			if (recs) fetchRecording()
		}
		else {
			marker.AvailabilityEnd = availabilityEndCache.get(_eventId)
			if (AvailabilityEnd !== marker.AvailabilityEnd) setAvailabilityEnd(marker.AvailabilityEnd)
			//console.debug("RecordingIndicators from cache", availabilityEndCache.size)
		}
	}
	else {
		return (<></>)
	}

	// unused
	//const seriesMarker = computed(() => rootStore.page.Recordings.Manager.getMarker(null, _seriesId)).get()
	//if (seriesMarker) console.debug("seriesMarker=", seriesMarker)
	// e.g. "rec_series_planned"

	/* LEAVE FOR TESTING PURPOSE MTV-1757 and MTV-1796
	const page = rootStore.page.Recordings.IndexPage
	if (page.oRecPlanned.isReady) {
		// page.oRecPlanned.DataArr?.map(i => { console.debug(i) })
		console.debug("_eventId %s, _seriesId %s, type %s, marker %o ", _eventId, _seriesId, marker.recType, marker)
	}
	*/
	//console.debug("marker= %o, seriesMarker %o, _seriesId %o, ProfileId %s, private %s, name %s, eventName %o", marker?.recType, seriesMarker?.recType, _seriesId, marker?.ProfileId, marker?.IsPersonal, rootStore.sso.getProfile(marker?.ProfileId)?.name, event.Title.Name, event.AvailabilityStartDateFormat("DD.MM.YYYY HH:mm"), event, marker)
	//console.debug("movie %o, ProfileId %s, private %s", movie, movie.ProfileId, movie.IsPersonal, "Aufgenommen von " + movie.ProfileNickname, rootStore.sso.getProfile(movie.ProfileId))
	const isProfileOwner = marker?.ProfileId === rootStore?.sso?.profile?.id

	const recTypesEpg = {
		rec_single_planned: {
			imgProps: { src: rec },
		},
		rec_single_complete: {
			imgProps: { src: rec_successful },
		},
		rec_single_failed: {
			imgProps: { src: rec_failed },
		},
		rec_series_planned: {
			imgProps: { src: rec_series },
		},
		rec_series_complete: {
			imgProps: { src: rec_series_episode_successful },
		},
		rec_series_failed: {
			imgProps: { src: rec_failed },
		}
	}

	const RecTypeEpg = recTypesEpg[marker?.recType]
	if (!RecTypeEpg) return (<></>)

	const indicators = []
	if (showText) {
		// MTVW-938: handle 'Failed' state
		if (marker.State === "Failed") {
			// seems not nessecary for series with text l10n.featureDetailsRecordingStatusSeriesFailed
			indicators.push({
				imgProps: { src: recording_failed, style: { left: 3, width: 20, height: 20, top: 1 } },
				txt: l10n.featureDetailsRecordingStatusFailed
			})
		}
		else {
			if (marker.recType === "rec_single_planned") {
				indicators.push({
					imgProps: { src: recording_status },
					txt: event?.getCurrentEventType === "n" ? l10n.featureDetailsRecordingStatusPlanned : l10n.featureDetailsRecordingStatusInProgress
				})
			}
			if (marker.recType === "rec_single_complete") {
				indicators.push({
					imgProps: { src: marker.IsDeleteProtected ? recording_archived : recording_status },
					//txt: l10n.featureDetailsRecordingStatusComplete
					// profile could have been deleted
					txt: marker.IsDeleteProtected ? isProfileOwner ? l10n.featureRecordingsArchived : l10n.featureRecordingsArchivedBy.format(rootStore.sso.getProfile(marker?.ProfileId)?.name) : marker.ProfileId === null || isProfileOwner || marker?.IsPersonal ?
						l10n.featureRecordingsSavedUntil.format(moment(marker?.AvailabilityEnd).format("DD.MM.YYYY")) : l10n.featureRecordingsRecordedBy.format(rootStore.sso.getProfile(marker?.ProfileId)?.name)
				})
			}
			if (marker.recType === "rec_series_planned") {
				indicators.push({
					imgProps: { src: recording_status },
					//txt: l10n.featureDetailsRecordingStatusSeriesPlanned
					txt: l10n.featureDetailsRecordingStatusPlanned
				})
				if (marker.isSeries) {
					indicators.push({
						imgProps: { src: recording_status_series, style: { left: 3, width: 20, height: 20, top: 1 } },
						txt: event.content.Season || event.content.Episode ? l10n.featureRecordingsSeasonRecording : l10n.featureRecordingsSeriesRecording
					})
				}
			}
			if (marker.recType === "rec_series_complete") {
				if (AvailabilityEnd) {
					indicators.push({
						imgProps: { src: marker.IsDeleteProtected ? recording_archived : recording_status },
						//txt: l10n.featureDetailsRecordingStatusComplete
						// profile could have been deleted
						txt: marker.IsDeleteProtected ? l10n.featureRecordingsArchived : marker.ProfileId === null || isProfileOwner || marker?.IsPersonal ?
							l10n.featureRecordingsSavedUntil.format(moment(AvailabilityEnd).format("DD.MM.YYYY")) : l10n.featureRecordingsRecordedBy.format(rootStore.sso.getProfile(marker?.ProfileId)?.name)
					})
				}
				//if (event?.Title?.isSeries && event?.content?.seriesCollectionId) {
				if (marker.isSeries) {
					indicators.push({
						imgProps: { src: recording_status_series, style: { left: 3, width: 20, height: 20, top: 1 } },
						txt: event.content.Season || event.content.Episode ? l10n.featureRecordingsSeasonRecording : l10n.featureRecordingsSeriesRecording
					})
				}
			}
		}
		// WORKAROUND isVisibilityValid
		if (!marker.IsPersonal && isProfileOwner && rootStore.page.Recordings.Manager.isVisibilityValid) {
			indicators.push({
				imgProps: { src: recording_visibility },
				txt: l10n.featureDetailsIndicatorStatusShared
			})
		}
	}
	if (indicators.length > 0) console.debug("indicators", indicators)

	return (
		<>
			{showText === true ?
				<div className="recordingIndicatorContainer" data-test="recording_indicator">
					{indicators?.length > 0 && (
						<div className="indicatorFrame">
							{/*
						<div className="recordingIconContainer" style={{ width: 25, height: 25, top: 2, display: "inline-flex" }} >
							<img alt="" className="recordingIndicatorIcon" style={{ width: 25, height: 25, margin: "unset" }} {...RecType.imgProps} />
						</div>
						<div className="recordingIndicatorText">{RecType.txt}</div>
						*/}
							{indicators?.map((item, ix) => (
								<div className="recordingIndicatorItem" key={ix}>
									<div className="recordingIconContainer" style={{ marginRight: 8, width: 25, height: 25, top: 2 }} >
										<img alt="" className="recordingIndicatorIcon" style={{ width: 25, height: 25, margin: "unset" }} {...item.imgProps} />
									</div>
									<div className="recordingIndicatorText" style={{ paddingRight: ix !== indicators.length - 1 ? 14 : 4 }}>{item.txt}</div>
								</div>
							))}
						</div>
					)}
				</div>
				:
				<div className="recordingIndicatorContainer" data-test="recording_indicator">
					{/*console.debug("marker epg", marker.recType, event.Title.Name, event.AvailabilityStartDateFormat("DD.MM.YYYY HH:mm"))*/}
					<img alt="" className="recordingIndicatorIcon" {...RecTypeEpg.imgProps} />
				</div>
			}
		</>
	)
})
